angular.module('todo')
    .component('todoCreate', {
        templateUrl: 'app/todo/create.html',
        controller: function ($rootScope, Todo) {

            this.$onInit = () => {
                this.topic = ""
            }

            this.save = () => {
                let todo = {
                    id: null,
                    topic: this.topic
                }
                Todo.save(todo).$promise.then(() => {
                    this.topic = ""
                    $rootScope.$broadcast('todo.updated')
                })
            }
        }
    })
